module.exports = __webpack_public_path__ + "img/2_25.a8694869.png";